module.exports = __webpack_public_path__ + "img/hit.ab610321.svg";